import { type HttpClientConfig } from '../../infra/http/HttpClient'
import { type ChatContactInfo } from '../domain/Chat'
import { ChatRepository } from '../infra/ChatRepository'
import { createChatHttpClient } from '../infra/createChatHttpClient'

export type GetChatsListRepositoryParams = {
  repository: ChatRepository
}

export function getUserContactInfo(
  config?: Partial<HttpClientConfig>,
  accessToken?: string
): Promise<ChatContactInfo> {
  const httpClient = createChatHttpClient(accessToken)
  const repository = new ChatRepository({ httpClient })

  return repository.getUserContactInfo(config)
}
